export enum ContactPointSystemType {
  PHONE = 'PHONE',
  FAX = 'FAX',
  EMAIL = 'EMAIL',
  PAGER = 'PAGER',
  URL = 'URL',
  SMS = 'SMS',
  OTHER = 'OTHER',
}
